<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24.242" height="33.305" viewBox="0 0 24.242 33.305">
    <g id="Gruppe_30" transform="translate(-158.25 -144.25)">
      <line id="Linie_1" x2="13" transform="translate(164.212 159.702)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <line id="Linie_3" x2="13" transform="translate(164.212 169.702)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <line id="Linie_4" x1="13" transform="translate(164.212 164.702)" fill="none" stroke="#a1a1a1" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_38" d="M178.468,148.534c-.812,0-1.374-.851-1.691-1.735a2.364,2.364,0,0,0-4.591,0c-.316.884-.879,1.735-1.691,1.735H169v3.534a1.1,1.1,0,0,0,1,1.178h8.97a1.1,1.1,0,0,0,1-1.178v-3.534Z" transform="translate(-4.11 0)" fill="none" stroke="#a1a1a1" stroke-linejoin="round" stroke-width="1.5"/>
      <ellipse id="Ellipse_8" cx="1" rx="1" transform="translate(169.212 149.702)" fill="none" stroke="#a1a1a1" stroke-linejoin="round" stroke-width="1.5"/>
      <path id="Pfad_39" d="M176.328,151h3.79a1.7,1.7,0,0,1,1.624,1.767V177.5a1.7,1.7,0,0,1-1.624,1.767H160.624A1.7,1.7,0,0,1,159,177.5V152.767A1.7,1.7,0,0,1,160.624,151h3.79" transform="translate(0 -2.466)" fill="none" stroke="#a1a1a1" stroke-linejoin="round" stroke-width="1.5"/>
    </g>
  </svg>
</template>

<script>
export default {
name: "notes"
}
</script>

<style scoped>

</style>